"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var context_1 = require("../../core/context");
var context_2 = require("../../core/context/context");
var i_st_1 = require("../../core/st/interface/i$st");
var vdom_1 = require("../vdom");
var attr_1 = require("./trait/attr");
var lang_1 = require("../../core/lang");
var dom_1 = require("../vdom/dom");
var store_1 = require("./trait/store");
var event_bus_1 = require("./trait/event-bus");
var call_on_context_change_1 = require("../../core/context/function/call-on-context-change");
var call_on_message_1 = require("../../core/event-bus/function/call-on-message");
var Component = /** @class */ (function () {
    function Component() {
        var _this = this;
        this.updateClassAndStyles = function () {
            // getter returns merged results from component and virutal node
            // assignment happens to recall the setter for change detection
            // this is necessary for outer class={[...]} and outer style={{ ... }} assignments
            if (_this.class && _this.class.length) {
                _this.class = _this.class;
            }
            if (_this.style && Object.keys(_this.style).length) {
                _this.style = _this.style;
            }
        };
        // internal state initialization
        this.INTERNAL = {
            attributes: {},
            options: Object.getPrototypeOf(this).constructor.COMPONENT_OPTIONS,
            resolveOnInitiallyRendered: function () {
            },
        };
        // @attr impl.
        attr_1.AttrTrait.enableFor(this);
        // @context, @onContextChange
        context_1.ContextTrait.enableFor(this);
        // @store
        store_1.StoreTrait.enableFor(this);
        // @onMessage
        event_bus_1.EventBusTrait.enableFor(this);
        // register with global instance registry
        core_1.st[i_st_1.GlobalCache.COMPONENT_INSTANCES].push(this);
    }
    Component.prototype.renderPartial = function (virtualNode, domNode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!domNode) {
                    domNode = this.el;
                }
                core_1.st.dom.removeChildren(domNode);
                return [2 /*return*/, core_1.st.render(virtualNode, domNode)];
            });
        });
    };
    Component.prototype.rerender = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vdom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.renderPartial(this.render(), this.el)];
                    case 1:
                        vdom = _a.sent();
                        this.onAfterRender();
                        return [2 /*return*/, vdom];
                }
            });
        });
    };
    Object.defineProperty(Component.prototype, "class", {
        // --- standard HTML attributes (pass-thru)
        get: function () {
            return this.INTERNAL[dom_1.CLASS_ATTRIBUTE_NAME] || [];
        },
        set: function (classes) {
            this.INTERNAL[dom_1.CLASS_ATTRIBUTE_NAME] = classes;
            if (this.el) {
                core_1.st.dom.setAttribute(dom_1.CLASS_ATTRIBUTE_NAME, lang_1.mergeArrays(classes, this.virtualNode.attributes[dom_1.CLASS_ATTRIBUTE_NAME]), this.el, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "style", {
        get: function () {
            return this.INTERNAL[dom_1.STYLE_ATTRIBUTE_NAME] || {};
        },
        set: function (style) {
            this.INTERNAL[dom_1.STYLE_ATTRIBUTE_NAME] = style;
            if (this.el) {
                core_1.st.dom.setAttribute(dom_1.STYLE_ATTRIBUTE_NAME, lang_1.mergeObjects(style, this.virtualNode.attributes[dom_1.STYLE_ATTRIBUTE_NAME]), this.el, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.renderSlot = function (slotName, defaults) {
        if (this.virtualNode.slotChildren[slotName]) {
            return this.virtualNode.slotChildren[slotName].children;
        }
        return defaults || vdom_1.tsx("fragment", null);
    };
    Component.prototype.renderChildren = function (defaults) {
        if (this.virtualNode.slotChildren[dom_1.DEFAULT_SLOT_NAME]) {
            return this.virtualNode.slotChildren[dom_1.DEFAULT_SLOT_NAME];
        }
        return defaults || vdom_1.tsx("fragment", null);
    };
    Component.prototype.onBeforeElCreate = function (virtualNode) {
    };
    Component.prototype.onAfterElCreate = function (el) {
    };
    Component.prototype.onBeforeElChildrenCreate = function () {
    };
    Component.prototype.onAfterElChildrenCreate = function () {
    };
    Component.prototype.onBeforeConnect = function () {
    };
    Component.prototype.onMessage = function (topicName, value) {
        call_on_message_1.callOnMessage(topicName, value, this);
    };
    Component.prototype.onContextChange = function (change) {
        call_on_context_change_1.callOnContextChange(change, this);
    };
    // internal web component standard method
    Component.prototype.connectedCallback = function () {
        this.INTERNAL.isConnected = true;
        awaitDisconnect(this);
        this.onConnect();
        this.doRender();
    };
    Component.prototype.onConnect = function () {
    };
    Component.prototype.onDisconnect = function () {
    };
    /**
     * Lifecycle method: Implement this method to dynamically accept or revoke attribute changes
     * @param name Name of the attribute
     * @param newValue Value to accept or revoke
     * @param oldValue Previous value
     */
    Component.prototype.shouldAttributeChange = function (name, newValue, oldValue) {
        return true;
    };
    /**
     * Overriding this method and not calling the super method
     * allows to fetch the original attribute value from VDOM (no DOM traversal string typecast)
     */
    Component.prototype.getAttribute = function (name, type) {
        // in case of DOM transparency and post-render time, the truth is the DOM
        if (type === attr_1.AttrType.DOM_TRANSPARENT && this.el) {
            return this.el.getAttribute(name);
        }
        return this.INTERNAL.attributes[name];
    };
    /**
     * Overriding this method and not calling the super method
     * allows to take the original attribute value from VDOM (no DOM traversal string typecast)
     */
    Component.prototype.setAttribute = function (name, value, type) {
        var prevValue = this.getAttribute(name, type);
        // implementation to pass a map of attributes at once
        // like: <Bar attrs={{ hidden: true, foo: '123', ... }} /> instead of writing
        // <Bar hidden={true} foo='123' />
        if (name === dom_1.ATTRS_ATTR_NAME) {
            for (var attrName in value) {
                this.setAttribute(attrName, value[attrName]);
            }
            return;
        }
        if (this.shouldAttributeChange(name, value, prevValue)) {
            // store internal attribute state value
            this.INTERNAL.attributes[name] = value;
            if (this.el) {
                // standard HTML attribute as per definition
                if ((core_1.st.dom.isStandardHTMLAttribute(name) ||
                    // type set on call of setAttribute as AttrType.DOM_TRANSPARENT
                    (typeof type !== lang_1.TYPE_UNDEFINED && type === attr_1.AttrType.DOM_TRANSPARENT) ||
                    // @attr(AttrType.DOM_TRANSPARENT)
                    attr_1.AttrTrait.getType(this, name) === attr_1.AttrType.DOM_TRANSPARENT)) {
                    // reflect to DOM (casts to string)
                    this.el.setAttribute(name, value);
                    // persist for re-renderings???
                    this.virtualNode.attributes[name] = value;
                }
            }
            // call lifecycle method
            this.onAttributeChange(name, value, prevValue);
        }
    };
    /**
     * Lifecycle method: Implement to get notified when attributes change
     */
    Component.prototype.onAttributeChange = function (name, newValue, oldValue) {
    };
    Component.prototype.onBeforeRender = function () {
    };
    Component.prototype.render = function () {
        if (typeof this.INTERNAL.options.tpl != lang_1.TYPE_FUNCTION) {
            return vdom_1.tsx("fragment", null);
        }
        return this.INTERNAL.options.tpl(this);
    };
    Component.prototype.onAfterRefChange = function (refName, refValue) {
    };
    Component.prototype.doRender = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vdom, nodesToRender;
            return __generator(this, function (_a) {
                if (!this.INTERNAL) {
                    this.disconnectedCallback();
                    return [2 /*return*/];
                }
                this.onBeforeRender();
                vdom = this.render();
                if (!vdom) {
                    throw new Error("The render() method or the template (tpl) of <" + this.constructor.name + " /> must return virtual nodes.");
                }
                nodesToRender = Array.isArray(vdom) ? __spreadArrays(vdom) : [vdom];
                // if there isn't a prev. VDOM state, render initially
                core_1.st.renderer.render(nodesToRender, this.el);
                this.updateClassAndStyles();
                // resolve promises for calls on this.initiallyRendered()
                this.INTERNAL.resolveOnInitiallyRendered();
                // call lifecycle method
                this.onAfterRender();
                return [2 /*return*/];
            });
        });
    };
    Component.prototype.onAfterRender = function () {
    };
    Component.prototype.dispatchEvent = function (eventName, init) {
        this.el.dispatchEvent(new CustomEvent(eventName.toLowerCase(), init));
    };
    Component.prototype.initiallyRendered = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.el)
                    return [2 /*return*/, Promise.resolve()];
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.INTERNAL.resolveOnInitiallyRendered = resolve;
                    })];
            });
        });
    };
    Component.prototype.disconnectedCallback = function () {
        if (this.INTERNAL) {
            if (this.INTERNAL.isConnected) {
                this.INTERNAL.isConnected = false;
            }
            else {
                return;
            }
        }
        this.onDisconnect();
        event_bus_1.EventBusTrait.disableFor(this);
        // purge from global instance registry
        // (e.g. doesn't retrigger render on TSS theme change)
        var index = core_1.st[i_st_1.GlobalCache.COMPONENT_INSTANCES].indexOf(this);
        if (index > -1) {
            core_1.st[i_st_1.GlobalCache.COMPONENT_INSTANCES].splice(index, 1);
        }
        // remove @context handlers
        context_2.removeContextChangeHandlersOfInstance(this);
        if (this.INTERNAL && this.INTERNAL.refs) {
            // reset @ref references
            for (var refName in this.INTERNAL.refs) {
                // @ts-ignore
                if (this.INTERNAL.refs[refName]) {
                    // sub-component GC
                    // @ts-ignore
                    exports.disconnectComponent(this.INTERNAL.refs[refName]);
                    // GC
                    // @ts-ignore
                    delete this.INTERNAL.refs[refName];
                }
            }
        }
        // GC
        if (this.el) {
            // @ts-ignore
            delete this.el.$stComponent;
            // @ts-ignore
            delete this.el.$stComponentRef;
            delete this.el;
        }
        delete this.mutationObserver;
        delete this.virtualNode;
        delete this.parent;
        delete this.childComponents;
        delete this.INTERNAL;
    };
    return Component;
}());
exports.Component = Component;
if (!core_1.st.component) {
    core_1.st.component = Component;
}
else {
    if (process.env.NODE_ENV === 'development') {
        core_1.st.warn('Module component is loaded twice. Check for duplicate famework import!');
    }
}
exports.getComponent = function (className) { return core_1.st[i_st_1.GlobalCache.COMPONENT_REGISTRY][className]; };
exports.disconnectComponent = function (component) {
    if (component.INTERNAL) {
        if (component.mutationObserver) {
            component.mutationObserver.disconnect();
        }
        if (component.childComponents) {
            for (var _i = 0, _a = component.childComponents; _i < _a.length; _i++) {
                var childComponent = _a[_i];
                exports.disconnectComponent(childComponent);
            }
        }
        component.disconnectedCallback();
    }
};
var awaitDisconnect = function (component) {
    var onMutation = function (mutationsList) {
        for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
            var mutation = mutationsList_1[_i];
            if (!component.INTERNAL || !component.el)
                continue;
            if (Array.prototype.indexOf.call(mutation.removedNodes, component.el) > -1) {
                exports.disconnectComponent(component);
            }
        }
    };
    if (typeof MutationObserver !== lang_1.TYPE_UNDEFINED) {
        // attached component
        if (component.el.parentNode) {
            // old browsers might not call .onDisconnect() and lead to memory overhead
            // but that is a compromise that seems to be sane
            // if necessary, add: mutationobserver-shim in your application bundle
            component.mutationObserver = new MutationObserver(onMutation);
            component.mutationObserver.observe(component.el.parentNode, {
                attributes: false,
                childList: true,
                subtree: false
            });
        }
        else {
            // some intermediate disconnection state
            // make sure, GC is running
            exports.disconnectComponent(component);
        }
    }
};
if (!core_1.st.getComponent) {
    core_1.st.getComponent = exports.getComponent;
}
//# sourceMappingURL=component.js.map